import { useContext } from 'react'
import { AccountContextProps, AccountContext } from '../contexts/AccountProvider'

const useAccount = () => {
  return useContext(AccountContext) as AccountContextProps
}

export default useAccount
